// extracted by mini-css-extract-plugin
export default {"root":"table_root__FeG6a"};